// Importar contatos de arquivo (/contacts/import) — tela própria do mockup
// "Aeros Dark — Importar contatos de arquivo". O fluxo das 3 etapas vive em
// ContactImportModal, reaproveitado aqui com `inline`: a tela é só o
// breadcrumb e o cartão. Duplicar as etapas criaria dois lugares para
// corrigir a mesma regra de importação.
import React from "react";
import { useHistory } from "react-router-dom";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { makeStyles } from "@material-ui/core/styles";

import MainContainer from "../../components/MainContainer";
import ContactImportModal from "../../components/ContactImportModal";
import { i18n } from "../../translate/i18n";
import useCampaignPageStyles from "../Campaigns/campaignPageStyles";

const useStyles = makeStyles((theme) => ({
  crumb: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    fontSize: 12.5,
    color: theme.palette.text.secondary,
    "& .MuiSvgIcon-root": {
      fontSize: 16,
      color: theme.palette.aeros.textTertiary,
    },
  },
  crumbLink: {
    background: "none",
    border: "none",
    padding: 0,
    font: "inherit",
    color: "inherit",
    cursor: "pointer",
    "&:hover": { color: theme.palette.text.primary },
  },
  crumbCurrent: {
    fontWeight: 700,
    color: theme.palette.text.primary,
    fontSize: 16,
    letterSpacing: "-0.02em",
  },
  wrap: { paddingTop: 16 },
}));

const ContactImport = () => {
  const c = useCampaignPageStyles();
  const classes = useStyles();
  const history = useHistory();

  const voltar = () => history.push("/contacts");

  return (
    <MainContainer>
      <div className={c.pageHeader}>
        <div className={classes.crumb}>
          <button type="button" className={classes.crumbLink} onClick={voltar}>
            {i18n.t("aeros.contactImport.breadcrumb")}
          </button>
          <ChevronRightIcon />
          <span className={classes.crumbCurrent}>
            {i18n.t("aeros.contactImport.pageTitle")}
          </span>
        </div>
      </div>

      <div className={c.pageBody}>
        <div className={classes.wrap}>
          <ContactImportModal inline open onClose={voltar} onStarted={voltar} />
        </div>
      </div>
    </MainContainer>
  );
};

export default ContactImport;
